import React from 'react'
import {withStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

const useStyles = theme => ({
  root: {
    width: '100%',
    maxWidth: 270,        
  },
  inline: {
    display: 'inline',
  },
});



class HeaderMenu extends React.Component {
  
  constructor(props){
    super(props);      
    this.state = { 
      text: '',                   
    }
  }  

  getAvatar = () => {

    const { info } = this.props;
    let initial = ""
      
    if(info && info.nome && info.nome.length > 0){
      initial += info.nome.substring(0, 1)
    } else {
      return ""
    }
    if(info.lastName && info.lastName.length > 0){
      initial += info.lastName.substring(0, 1)
    }
    return <Avatar src={`https://app.adsim.co/image/obter?img=${info.image}`} >{initial}</Avatar>
  }

  getUserName = () => {
    const { info } = this.props;
    let name = ''
    if(info && info.nome){
      name += info.nome
      name += ' '
    } 
    if(info && info.lastName){
      name += info.lastName
    }
    return name
  }
  
  getComanyName = () => {
    
    const { info } = this.props;

    if(info && info.nomeEmpresa){
      return info.nomeEmpresa
    }
    
    if(info && info.companyBrand){
      return info.companyBrand
      
    }     
    return "Not Defined"
  }
  

  render(){
    

    const { classes } = this.props;

    return (
      <List className={classes.root} >
        <ListItem >
          <ListItemAvatar>
            {this.getAvatar()}
          </ListItemAvatar>
          <ListItemText 
                primary={this.getUserName()}
                secondary={this.getComanyName()}
          />
        </ListItem>     
      </List>
    )
  }
  
}

export default withStyles(useStyles)(HeaderMenu)